<!--  Created by   : Namit Tiwari                                                             -->
<!--  Create Dated : 28-Apr-2021                                                              -->
<!--  Purpose      : Admit Card for Canddiate                                        -->
<template>
  <div>
    <div id="divAdmitCardPrint">
      <div class="page">
        <div class="subPage">
          <table style="width: 100%">
            <tr style="display: none;">
              <td colspan="3" align="right">
                <span
                  style="text-decoration: underline; font-weight: bold;font-size:14px;"
                  >Annexure III</span
                >
              </td>
            </tr>
            <tr>
              <td style="width: 12%">
                <img
                  src="../assets/images/AOC_Logo.png"
                  alt="AOCLOGO"
                  style="height: 80px; width: 70px;"
                />
              </td>
              <td style="width: 76%">
                <table style="width: 100%">
                  <tr>
                    <td align="center">
                      <!-- <span style="text-decoration: underline; font-weight: bold;font-size:14px;">ADMIT CARD FOR {{ lblExamType }} : ARMY ORDNANCE CORPS</span> -->
                      <span
                        style="text-decoration: underline; font-weight: bold;font-size:14px;"
                        >ADMIT CARD</span
                      >
                    </td>
                  </tr>
                  <tr>
                    <td align="center">
                      <span
                        style="text-decoration: underline; font-weight: bold;font-size:14px;"
                        >ARMY ORDNANCE CORPS</span
                      >
                    </td>
                  </tr>
                  <tr>
                    <td align="center">
                      <span
                        style="text-decoration: underline; font-weight: bold;font-size:14px;"
                        >RECRUITMENT FOR DEFENCE CIVILIAN EMPLOYEES</span
                      >
                    </td>
                  </tr>
                  <tr>
                    <td Style="letter-spacing:2px;" align="center">
                      <span
                        style="text-decoration: underline; font-weight: bold;font-size:12px; letter-spacing:1px;"
                        >ONLINE APPLICATION NO. : {{ lblApplNo }}</span
                      >
                    </td>
                  </tr>
                  <!-- <tr>
                                    <td align="center">
                                        <br>
                                        <span style="font-weight: bold">CENTRAL RECRUITING CELL : {{lblrecCellName}}</span>
                                    </td>
                                </tr> -->
                </table>
              </td>
              <td style="width: 12%">
                <img
                  src="../assets/images/satyameva_jayate.png"
                  alt="SatyamevaJayateLogo"
                  style="height: 80px; width: 70px;"
                />
              </td>
            </tr>
          </table>

          <br />
          <table style="width: 100%; border: 1px solid darkgray">
            <tr>
              <td
                colspan="2"
                style="width: 50%; border-top:  0.01em solid darkgray;border-right:  0.01em solid darkgray;"
                align="center"
                valign="middle"
              >
                <span style="font-weight: bold">Exam Centre</span>
              </td>
              <td
                style="width: 25%; border-top:  0.01em solid darkgray;border-right:  0.01em solid darkgray;"
                align="center"
                valign="middle"
              >
                <span style="font-weight: bold">Date & Time of Report</span>
              </td>
              <td
                style="width: 25%; border-top:  0.01em solid darkgray; v-align: middle"
                align="center"
              >
                <span style="font-weight: bold">Post applied for</span>
              </td>
            </tr>
            <tr>
              <td
                colspan="2"
                style="width: 50%; height: 70px;  border-top:  0.01em solid darkgray;border-right:  0.01em solid darkgray;"
                align="center"
              >
                <span>{{ lblVenue }}</span>
              </td>
              <td
                style="width: 25%; height: 25px; border-top:  0.01em solid darkgray;border-right:  0.01em solid darkgray;"
              >
                {{ lblReportingDate }} {{ lblReportingTime }}
              </td>
              <td
                style="width: 25%; height: 25px; border-top:  0.01em solid darkgray;"
              >
                <span>{{ lblCategory }}</span>
              </td>
            </tr>
            <tr>
              <td
                colspan="2"
                style="width: 50%;  border-top:  0.05em solid darkgray;border-right:  0.01em solid darkgray;;text-align:center;"
              >
                <div
                  style="padding-top:10px;"
                  id="divQRCodeData"
                  onContextMenu="return true;event.stopPropagation();"
                ></div>
                <!-- {{ lblApplNo }} -->
              </td>
              <td
                style="width: 25%;  border-top:  0.01em solid darkgray;border-right:  0.01em solid darkgray;; padding: 5px"
                align="center"
              >
                <img id="candImage" alt="CandidateImage" style="height: 120px; width: 100px" />
              </td>
              <td
                style="width: 25%;  border-top:  0.01em solid darkgray;padding: 5px"
                align="center"
              >
                <div
                  style="height: 120px; width: 100px;border:solid thin;text-align:center;padding-top:35px;"
                >
                  (Paste your latest colour photograph Size 3.5cm X 4.5cm)
                </div>
              </td>
            </tr>
            <tr>
              <td
                style="width: 20%;  border-top:  0.01em solid darkgray;border-right:  0.01em solid darkgray;;height:30px;"
              >
                <span style="font-weight: bold">Applicant Name</span>
              </td>
              <td
                style="width: 30%;  border-top:  0.01em solid darkgray;border-right:  0.01em solid darkgray;"
              >
                <span>{{ lblCandName }}</span>
              </td>
              <td
                style="width: 25%;  border-top:  0.01em solid darkgray;border-right:  0.01em solid darkgray;"
              >
                <span style="font-weight: bold">Father/Guardian Name</span>
              </td>
              <td style="width: 25%;  border-top:  0.01em solid darkgray;">
                <span>{{ lblFatherName }}</span>
              </td>
            </tr>
            <tr>
              <td
                style="width: 20%;  border-top:  0.01em solid darkgray;border-right:  0.01em solid darkgray;;height:30px;"
              >
                <span style="font-weight: bold">Gender</span>
              </td>
              <td
                style="width: 30%;  border-top:  0.01em solid darkgray;border-right:  0.01em solid darkgray;"
              >
                {{ lblGender }}
              </td>
              <td
                style="width: 25%;  border-top:  0.01em solid darkgray;border-right:  0.01em solid darkgray;"
              >
                <span style="font-weight: bold">Aadhar No</span>
              </td>
              <td style="width: 25%;  border-top:  0.01em solid darkgray;">
                {{ lblAadharNo }}
              </td>
            </tr>
            <tr>
              <td
                style="width: 20%;  border-top:  0.01em solid darkgray;border-right:  0.01em solid darkgray;;height:30px;"
              >
                <span style="font-weight: bold">Mother’s Name</span>
              </td>
              <td
                style="width: 30%;  border-top:  0.01em solid darkgray;border-right:  0.01em solid darkgray;"
              >
                <span>{{ lblMotherName }}</span>
              </td>
              <td
                style="width: 25%;  border-top:  0.01em solid darkgray;border-right:  0.01em solid darkgray;"
              >
                <span style="font-weight: bold">Date of Birth</span>
              </td>
              <td style="width: 25%;  border-top:  0.01em solid darkgray;">
                {{ lblDOB }}
              </td>
            </tr>

            <tr>
              <td
                style="width: 20%;  border-top:  0.01em solid darkgray;border-right:  0.01em solid darkgray;;height:30px;"
              >
                <span style="font-weight: bold"
                  >Caste (UR/ OBC/ SC/ ST/ EWS)</span
                >
              </td>
              <td
                style="width: 30%; border-top:  0.01em solid darkgray;border-right:  0.01em solid darkgray;"
              >
                <span>{{ lblCaste }}</span>
              </td>
              <td
                style="width: 25%;  border-top:  0.01em solid darkgray;border-right:  0.01em solid darkgray;;height:30px;"
              >
                <span style="font-weight: bold">Category (MSP/ ESM/ PwBD)</span>
              </td>
              <td style="width: 25%;  border-top:  0.01em solid darkgray;">
                <span>{{ lblCategoryAgain }}</span>
              </td>
            </tr>
            <tr>
              <td
                style="width: 20%;  border-top:  0.01em solid darkgray;border-right:  0.01em solid darkgray;;height:30px;"
              >
                <span style="font-weight: bold">Caste cert No & Date</span>
              </td>
              <td
                style="width: 30%;  border-top:  0.01em solid darkgray;border-right:  0.01em solid darkgray;"
              >
                {{ lblCasteCertificateNo }} {{ lblCastDate }}
              </td>
              <td
                style="width: 25%;  border-top:  0.01em solid darkgray;border-right:  0.01em solid darkgray;"
              >
                <span style="font-weight: bold">Category Cert No & Date</span>
              </td>
              <td style="width: 25%;  border-top:  0.01em solid darkgray;">
                {{ lblCategoryCertificateNo }} {{ lblCategoryDate }}
              </td>
            </tr>
            <tr>
              <td
                style="width: 20%;  border-top:  0.01em solid darkgray;border-right:  0.01em solid darkgray;;height:30px;"
              >
                <span style="font-weight: bold">{{ lblMatricText }}</span>
              </td>
              <td
                style="width: 30%;  border-top:  0.01em solid darkgray;border-right:  0.01em solid darkgray;"
              >
                {{ lblMatricCertNo }}
              </td>
              <td
                style="width: 25%;  border-top:  0.01em solid darkgray;border-right:  0.01em solid darkgray;"
              >
                <span style="font-weight: bold">Identification Marks</span>
              </td>
              <td style="width: 25%;  border-top:  0.01em solid darkgray;">
                <span>{{ lblIdentificationMarks }}</span>
              </td>
            </tr>
            <tr>
              <td
                style="width: 20%; border-top:  0.01em solid darkgray;border-right:  0.01em solid darkgray;;height:30px;"
              >
                <span style="font-weight: bold">Year of Passing</span>
              </td>
              <td
                style="width: 30%;  border-top:  0.01em solid darkgray;border-right:  0.01em solid darkgray;"
              >
                {{ lblYearOfPassing }}
              </td>
              <td
                style="width: 25%;  border-top:  0.01em solid darkgray;border-right:  0.01em solid darkgray;"
              >
                <!-- <span style="font-weight: bold">Post</span> -->
              </td>
              <td style="width: 25%; border-top:  0.01em solid darkgray;">
                <!-- {{ lblPost }} -->
              </td>
            </tr>
          </table>

          <!-- <table style="width: 100%;">
                    <tr>
                        <td style="width: 20%; ">

                        </td>
                        <td style="width: 30%; ">
                            Applicant’s Signature :
                        </td>
                        <td style="width: 25%;padding-top:5px; ">
                            <img id="candSignature" style="height: 40px; width: 130px;border:none;" />
                        </td>
                        <td style="width: 25%;">

                        </td>
                    </tr>
                </table> -->
          <br />
          <br />
          <p style="font-weight: bold">Instructions</p>
          <table style="width: 100%;letter-spacing:0.5px">
            <tr>
              <td style="width: 5%;valign:top;" valign="top"><br />1.</td>
              <td style="width: 95%;text-align:justify">
                <br /><span
                  >Candidate should bring the following documents at Rally
                  Site</span
                >
              </td>
            </tr>
            <tr>
              <td style="width: 5%"></td>
              <td style="width: 95%">
                <table>
                  <tr>
                    <td style="width: 10%;">( a )</td>
                    <td style="width: 90%">
                      <span>Printout copy of this Admit Card alongwith latest passport size photo duly affixd.
(eAdmit Cards are not permitted as mobiles are not allowed on rally site).</span>
                    </td>
                  </tr>
                  <tr>
                    <td style="width: 10%;" valign="top">( b )</td>
                    <td style="width: 90%;text-align:justify">
                      <span
                        >Original Photo Identity (Aadhaar Card/ Voter’s ID/
                        Passport/ Service ID Card issued to employees by Central
                        Govt/State Govt/PSUs/ PAN Card/ Ex-serviceman discharge
                        book issued by Ministry of Defence/ Any other photo
                        identity proof issued by Central Govt/State Govt).</span
                      >
                    </td>
                  </tr>
                  <tr>
                    <td style="width: 10%;">( c )</td>
                    <td style="width: 90%;text-align:justify">
                      <span
                        >Original matriculation certificate alongwith original
                        marks sheet.</span
                      >
                    </td>
                  </tr>
                  <tr>
                    <td style="width: 10%;">( d )</td>
                    <td style="width: 90%;text-align:justify">
                      <span
                        >Original mandatory Education Qualification Certificate
                        (if other than matriculation). Original mark sheets of
                        this Qualification.</span
                      >
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </div>
        <span class="FooterRight">Page 1 of 2</span>
      </div>
      <div class="page">
        <div class="subPage">
          <table style="width: 100%;letter-spacing:0.5px">
            <tr>
              <td style="width: 5%"></td>
              <td style="width: 95%">
                <table>
                  <tr>
                    <td style="width: 10%;">( e )</td>
                    <td style="width: 90%;text-align:justify">
                      <span
                        >Original Caste Certificate for those belonging to
                        SC/ST/OBC/EWS.</span
                      >
                    </td>
                  </tr>
                  <tr>
                    <td style="width: 10%;">( f )</td>
                    <td style="width: 90%;text-align:justify">
                      <span
                        >Original Category Certificate for those applying under
                        ESM, MSP & PwBD.</span
                      >
                    </td>
                  </tr>
                  <tr>
                    <td style="width: 10%;">( g )</td>
                    <td style="width: 90%;text-align:justify">
                      <span
                        >Original Experience Certificate for mandatory
                        experience required for the post applied for (Refer to
                        Part III of Application Form Para No.19)</span
                      >
                    </td>
                  </tr>
                  <tr>
                    <td style="width: 10%;">( h )</td>
                    <td style="width: 90%;text-align:justify">
                      <span
                        >Original NOC issued by Competent Authority for Serving Personnel and Central
Government Employees/Departmental Candidates.</span
                      >
                    </td>
                  </tr>
                </table>

                <div style="border:solid 1px;padding:5px;">
                  Note : All above mentioned documents being produced in
                  Original at Rally site will be same as per details furnished
                  in the Application Form by the Candidate.
                </div>
              </td>
            </tr>
            <tr>
              <td style="width: 5%" valign="top"><br />2.</td>
              <td style="width: 95%;text-align:justify">
                <br />
                <u><b>Venue.</b></u> The exact venue of the Rally will be
                displayed at Railway Station (MCO) / Bus Stand of the location
                of the Exam Centre given above.
              </td>
            </tr>
            <tr>
              <td style="width: 5%" valign="top"><br />3.</td>
              <td style="width: 95%;text-align:justify">
                <br />
                <u><b>Report Time.</b></u> Please note that entry into Rally
                site will close 30 minutes before the report time for frisking
                and attendance purposes. No candidate shall be allowed entry
                into rally site after closure of the entry.
              </td>
            </tr>
            <tr>
              <td style="width: 5%" valign="top"><br />4.</td>
              <td style="width: 95%;text-align:justify">
                <br />
                Candidates are advised to visit the rally venue at least one day
                in advance and familiarize themselves with the itinerary to
                avoid the last minute hassle in their own interest.
              </td>
            </tr>
            <tr>
              <td style="width: 5%" valign="top"><br />5.</td>
              <td style="width: 95%;text-align:justify">
                <br />
                The candidates are advised not to bring any valuable/costly
                items to the rally site, as safe keeping of the same cannot be
                assured. Exam Centre will not be responsible for any loss in
                this regard.
              </td>
            </tr>
            <tr>
              <td style="width: 5%" valign="top"><br />6.</td>
              <td style="width: 95%;text-align:justify">
                <br />
                Attendant with PwBD candidates will not be allowed beyond entry point.
              </td>
            </tr>
            <tr>
              <td style="width: 5%" valign="top"><br />7.</td>
              <td style="width: 95%;text-align:justify">
                <br />
                Successful candidates in physical/skill test are to register their biometric. Candidates in their
own interest are advised not to put any material on their fingers which obstructs the image of
biometrics.
              </td>
            </tr>
            <tr>
              <td style="width: 5%" valign="top"><br />8.</td>
              <td style="width: 95%">
                <br />
                <u><b>COVID-19 Protocols</b></u>
                <table>
                  <tr>
                    <td style="width: 10%;">( a )</td>
                    <td style="width: 90%;text-align:justify">
                      <span
                        >Wearing of mask/face cover is mandatory for all
                        candidates. Candidates without mask/face cover will not
                        be allowed entry into the rally.
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td style="width: 10%;">( b )</td>
                    <td style="width: 85%;text-align:justify">
                      <span
                        >Candidates, however, will have to remove their masks
                        for verification, whenever required by the examination
                        functionaries.</span
                      >
                    </td>
                  </tr>
                  <tr>
                    <td style="width: 10%;">( c )</td>
                    <td style="width: 85%;text-align:justify">
                      <span
                        >Candidates must carry his/her own hand sanitizer (small
                        size) in a transparent bottle.</span
                      >
                    </td>
                  </tr>
                  <tr>
                    <td style="width: 10%;">( d )</td>
                    <td style="width: 85%;text-align:justify">
                      <span
                        >Candidates to follow COVID 19 norms of social
                        distancing as well as personal hygiene inside rally
                        site.</span
                      >
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </div>
        <span class="FooterRight" style="font-weight: bold; margin-top: 20px; ">DO NOT FOLD THIS ADMIT CARD</span>
        <span class="FooterRight">Page 2 of 2</span>
      </div>
    </div>
    <input type="button" value="Print" v-on:click="printpdf()" v-if="false" />
  </div>
</template>
<script>
import vue from "vue";
import Router from "vue-router";
import "jspdf/dist/polyfills.es.js";
import { jsPDF } from "jspdf";
import axios from "axios";
import config from "@/router/globalConfig";
export default {
  name: "AdmitCard",
  props: {
    candidateID: { type: String, required: true },
    eventBus: { type: Object }
  },
  components: {},
  data() {
    return {
      lblExamType: "",
      lblrecCellName: "",
      lblVenue: "",
      lblReportingDate: "",
      lblReportingTime: "",
      lblCategory: "",
      lblApplNo: "",
      lblCandName: "",
      lblFatherName: "",
      lblMotherName: "",
      lblAadharNo: "",
      lblEmailID: "",
      lblDOB: "",
      lblCaste: "",
      lblCategoryAgain: "",
      lblCasteCertificateNo: "",
      lblCastDate: "",
      lblCategoryCertificateNo: "",
      lblCategoryDate: "",
      lblMatricText: "",
      lblMatricCertNo: "",
      lblIdentificationMarks: "",
      lblYearOfPassing: "",
      lblPost: "",
      lblReportingEmailID: "",
      isPrintClick: false,
      lblGender: "",
      waterMarkText:"",
      waterMarkImage:"",
    };
  },
  methods: {
    getCandidateDetail() {
      axios
        .get(config.WEB_API_PATH + "Report/GetAdmitCard", {
          headers: {
            __RequestVerificationToken: config.AF_Token,
            Authorization: config.LOG_Token
          },
          params: { candidateID: this.candidateID, type: 1 },
          crossdomain: true
        })
        .then(
          response => {
            //console.log(response.data.result);
            this.setCandDetails(response.data.result[0]);
            let divQRCodeData = document.getElementById("divQRCodeData");
            let QRCodeData = response.data.result1;

            this.waterMarkText = this.lblCandName + '-' + this.lblApplNo + '-' + response.data.result4;
            this.waterMarkImage = response.data.result5;

            let img = document.createElement("img");
            img.src = "data:image/jpg; base64," + QRCodeData;
            divQRCodeData.innerHTML = "";
            divQRCodeData.appendChild(img);

            let candImage = document.getElementById("candImage");
            candImage.src = "data:image/jpg; base64," + response.data.result2;

            let candSignature = document.getElementById("candSignature");
            if(candSignature ){
            candSignature.src =
              "data:image/jpg;base64," + response.data.result3;
            }
          },
          error => {
            alert("error : " + error.response);
          },
          failure => {
            alert("failure : " + failure.response);
          }
        );
    },
    setCandDetails(data) {
      if (data) {
        this.lblApplNo = data[1];
        this.lblPost = data[6];
        this.lblCategoryAgain = data[8];
        this.lblCaste = data[10];

        this.lblCandName = data[11];
        this.lblDOB = data[12];
        this.lblFatherName = data[13];
        this.lblMotherName = data[14];
        this.lblEmailID = data[15];
        this.lblAadharNo = data[17];
        this.lblCasteCertificateNo = data[18];
        this.lblCastDate = data[19];
        this.lblCategoryCertificateNo = data[20];
        this.lblCategoryDate = data[21];
        this.lblMatricText = data[22];
        this.lblMatricCertNo = data[23];
        this.lblYearOfPassing = data[24];
        this.lblIdentificationMarks = data[25];

        this.lblExamType = data[27];
        this.lblCategory = data[28];
        this.lblReportingDate = data[30];
        this.lblReportingTime = data[32];
        this.lblVenue = data[33] + " " + data[34];
        this.lblrecCellName = data[35];
        this.lblReportingEmailID = data[36];
        this.lblGender = data[37];
      }
    },
    printpdf() {
      let me = this;
      var watText = this.waterMarkText;
      var watImg = this.waterMarkImage;  
      //this.isPrintClick = true;
      let source = window.document.getElementById("divAdmitCardPrint")
        .innerHTML;
      let doc = new jsPDF("p", "pt", "a4");
      doc.html(source, {
        callback: function(pdf) {
          var totalPages = doc.internal.getNumberOfPages();          

          for (var i = 1; i <= totalPages; i++) {
            doc.setPage(i);
            doc.setTextColor(218, 220, 224);

             var min = 4;
            var max = 6;            
            var numberOfWaterMark = Math.floor(Math.random() * (max - min + 1) + min);
            var incrementedNumber = 250 + numberOfWaterMark;

            doc.text(watText, 50, incrementedNumber, { angle: 35, });
            
            min = 50; max=100;
            incrementedNumber += Math.floor(Math.random() * (max - min + 1) + min);
            if(i != 1)
            {
              doc.text(watText, 50, incrementedNumber, { angle: 25, });
            }

            min = 150; max=200;
            incrementedNumber += Math.floor(Math.random() * (max - min + 1) + min);
            doc.text(watText, 50, incrementedNumber, { angle: 15, });

            min = 200; max=300;
            incrementedNumber += Math.floor(Math.random() * (max - min + 1) + min);
            doc.text(watText, 50, incrementedNumber, { angle: 35, });
            
             min = 300; max=350;
            incrementedNumber += Math.floor(Math.random() * (max - min + 1) + min);
            doc.text(watText, 50, incrementedNumber, { angle: 35, });

            if (numberOfWaterMark > 4)
            {
              min = 350; max=450
              incrementedNumber += Math.floor(Math.random() * (max - min + 1) + min);
              doc.text(watText, 50, incrementedNumber, { angle: 30, });              
            }
            if (numberOfWaterMark > 5)
            {
              min = 405; max=500;
              incrementedNumber += Math.floor(Math.random() * (max - min + 1) + min);
              doc.text(watText, 50, incrementedNumber, { angle: 20, });   
            }
           
            doc.text(watText, 50, doc.internal.pageSize.height - 10, { angle: 5, });  
            doc.addImage(watImg, 'PNG', 0, 0, 600, 842);
          }
          pdf.save(me.lblApplNo + "_AdmitCard.pdf");
        }
      });
    }
  },
  computed: {},
  mounted() {
    if (this.eventBus) {
      let _printPDF = this.printpdf;
      let _getCandidateDetail = this.getCandidateDetail;
      this.eventBus.$on("printPDF", function() {
        _printPDF();
      });
      this.eventBus.$on("getCandidateDetail", function() {
        _getCandidateDetail();
      });
    }
  },
  watch: {}
};
</script>
<style scoped>
table {
  border-collapse: collapse;
}
td {
  padding-bottom: 5px;
  padding-left: 5px;
}
.CandInfo .Flex_Cell {
  border: solid 1px black;
  font-size: 7pt;
}
.page {
  width: 6.25in;
  height: 8.75in;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 0;
  border: 1px #d3d3d3 solid;
  border-radius: 5px;
  color: black;
  padding: 25px;
  font-size: 8.5pt;
  /* width: 8.27in;
    height: 11.60in; */
  /* margin-top: 0.2in; */
  /* background: white; */
  /* box-shadow: 0 0 5px rgb(0 0 0 / 10%); */
  /* overflow: hidden; */
  /* padding: 0.5in; */
  /* position: relative; */
  /* background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center; */
}
.subPage {
  margin: 0in;
  /* border: solid 1px gainsboro; */
  max-height: 8.2in;
  overflow: hidden;
  border-radius: 4px;
}
.FooterRight {
  /* position: relative; */
  /* bottom: 20px; */
  /* right: -5px; */
  /* font-size: 10pt; */
  font-family: Arial;
  /* font-weight: bold; */
  /* color: white; */
  /* background-color: black; */
  padding: 2px 8px;
  border-radius: 5px;
  width: 100%;
  display: block;
  text-align: center;
  /* margin-top: -20px; */
  margin-bottom: 3px;
}
span {
  letter-spacing: 0.5px;
}
</style>
<style scoped>
@media screen and (max-width: 800px) {
  .EntryBlock {
    width: 80%;
  }
  #divApplication {
    display: block;
    height: auto;
  }
  #location {
    width: 70%;
  }
  .PopUpCover {
    right: 0px !important;
    left: 18px !important;
  }
  .EntryBlock {
    width: 100%;
  }
  fieldset > div {
    width: calc(100vw - 15px);
    overflow: auto;
  }
  .tblEntryForm {
    width: calc(100vw - 35px);
  } /* width 15px less*/
  .tblEntryForm .Flex_Row {
    display: flex;
    flex-wrap: wrap;
  } /* this is responsible for cell wraping*/
  .tblEntryForm .Flex_Row > .Flex_Cell {
    width: 50% !important;
  } /* width of any cell time of screen sizing*/
  .tblEntryForm .Flex_Row > .Flex_Cell_Inline {
    width: 50% !important;
    line-height: 36px;
  } /* width of any cell time of screen sizing*/
  /* Auto calculate the height of the grid div for scrolling when screen size change*/
  .Location {
    max-width: calc(100vw - 30px) !important;
    width: calc(100vw - 40px) !important;
  }
  /*Overflow for horizontal */
  .ekkGrid .GridContent {
    overflow: unset;
  }
  /*then only horizontal scrolling works */
  .Flex_Table.ekkGrid .Flex_Row {
    width: 100%;
  }
}
@media screen and (max-width: 480px) {
  .EntryBlock {
    width: calc(100vw - 35px);
  }
  fieldset > div {
    width: calc(100vw - 35px);
    overflow: auto;
  }
  #location {
    width: 70%;
  }
  .PopUpCover {
    right: 0px !important;
    left: 18px !important;
  }
  .tblEntryForm > .Flex_Row > .Flex_Cell {
    width: 100% !important;
  }
  .tblEntryForm > .Flex_Row > .Flex_Cell_Inline {
    width: 100% !important;
    line-height: 36px;
  }
  .tblEntryForm .divHR {
    display: block;
  }
  .Flex_Table.ekkGrid.Location {
    max-width: calc(100vw - 40px) !important;
    width: calc(100vw - 40px) !important;
  }
  legend {
    width: calc(100vw - 40px) !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AdmitCard.vue